import React from 'react'
import { ReactNode } from 'react'
import { Container as BsContainer } from 'react-bootstrap'

type TContainer = {
  as?: React.ElementType<unknown>
  fluid?: boolean | 'sm' | 'md' | 'lg' | 'xl'
  bsPrefix?: string
  children?: ReactNode
  className?: string
  style?: React.CSSProperties
}

const Container = (props: TContainer): React.ReactElement => {
  const { as, bsPrefix = 'container', fluid = false, children, ...rest } = props

  return (
    <BsContainer {...rest} as={as} bsPrefix={bsPrefix} fluid={fluid}>
      {children}
    </BsContainer>
  )
}

export default Container
